import { render, staticRenderFns } from "./sspcn_signinDetail.vue?vue&type=template&id=53ec4f03&"
import script from "./sspcn_signinDetail.vue?vue&type=script&lang=js&"
export * from "./sspcn_signinDetail.vue?vue&type=script&lang=js&"
import style0 from "./sspcn_signinDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports